import React, { Component } from "react";
import { InputItem, Button, Toast } from "antd-mobile-v2";
import { get, headerGet, post } from "../../api/service/services";
import allUrl from "../../api/allUrl";
import tool from "../../api/tool";
import { createForm } from "rc-form";
import { userInfoData } from "../../public/getUserInfo";
import sectioValue from "../../api/service/secsstion";
import {sm4} from "sm-crypto";
import publicKey from "../../constants/publicKey";

import "./index.less";
class EditPhone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 60,
      flagCode: true,
      imageKey: {},
      status: 1,
      userData: {},
    };
  }
  // 获取验证码
  isPhone = () => {
    const { flagCode } = this.state;
    let imageCode = this.props.form.getFieldValue("imageCode");
    let phoneS = this.props.form.getFieldValue("phoneNumber");
    if (!imageCode) {
      Toast.fail("请输入图片验证码", 1);
      return;
    }
    if (!phoneS) {
      Toast.fail("请输入手机号", 1);
      return;
    }
    if (!flagCode) return;
    // 验证图片验证码
    headerGet(
      allUrl.register.captchaImage,
      {},
      { "Captcha-Code": imageCode, "Captcha-Key": this.state.imageKey.imageKey }
    ).then((res) => {
      if (res.success === true && res.code == 200) {
        this.getPhoneCode(phoneS);
      } else {
        Toast.fail(res.msg, 1, () => {
          this.getImageCode();
        });
      }
    });
  };
  // 获取手机验证码
  getPhoneCode = (phoneS) => {
    get(allUrl.register.getPhoneCode, { phone: phoneS })
      .then((res) => {
        if (res.success === true && res.code == 200) {
          this.countDown();
        } else {
          Toast.fail(res.msg, 1);
        }
      })
      .catch((error) => {
        Toast.fail("验证码获取失败", 1);
      });
  };
  componentDidMount() {
    this.getUserData();
    this.getImageCode();
  }
  // 获取个人信息
  getUserData = async () => {
    let userData = tool.get("userInfoData");
    if (userData) {
      this.setState({ status: userData.status, userData });
    } else {
      let data = await userInfoData();
      this.setState({ status: data.status, userData:data });
    }
  };
  // 获取图片验证码
  getImageCode = () => {
    get(allUrl.register.getImageCode, {})
      .then((res) => {
        if (res.success === true && res.code == 200) {
          let imgKey = res.data.key || "";
          let imageUrl = res.data.image || "";
          this.setState({
            imageKey: {
              imageKey: imgKey,
              imageUrl: imageUrl,
            },
          });
        } else {
          Toast.info(res.data.msg, 1);
        }
      })
      .catch((err) => {
        Toast.info("验证码获取失败，请重试", 1);
      });
  };
  // 倒计时
  countDown = () => {
    const { count, flagCode } = this.state;
    let timer = null;
    let num = count;
    this.setState({
      flagCode: false,
    });
    timer = setInterval(() => {
      if (num <= 1) {
        clearInterval(timer);
        num = 60;
        this.setState({
          flagCode: true,
        });
      }
      num--;
      this.setState({
        count: num,
      });
    }, 1000);
  };
  // 数据提交
  onSubmit = () => {
    const { userData } = this.state;
    this.props.form.validateFields((error, values) => {
      if (error) {
        let errorData = Object.keys(error)[0];
        Toast.info(error[errorData].errors[0].message, 1);
        return;
      }
      if (this.state.status + 1 > 4) {
        Toast.info("超过修改次数，不可修改", 1);
        return;
      }
      if (values.phoneNumber == userData.phoneNumber) {
        Toast.info("手机号不是新手机号", 1);
        return;
      }
      values["userCode"] = sectioValue.get("acount");
      this.editPhone(values);
    });
  };
  editPhone = (values) => {
    values.newPassWordVerify=sm4.encrypt(values.newPassWordVerify,publicKey) 
    post(allUrl.register.editPhone, values, {
      "Content-Type": "application/json;charset=UTF-8",
      "Captcha-SMS-Code": this.props.form.getFieldValue("phoneCode"),
    })
      .then((res) => {
        if (res.success === true && res.code == 200) {
          Toast.success("修改成功", 1, () => {
            this.props.history.push("/persCenter");
            tool.remove("userInfoData");
          });
        } else {
          Toast.info(res.msg, 1, () => {
            this.getImageCode();
          });
        }
      })
      .catch((error) => {
        if (error.data && error.data.msg) {
          Toast.info(error.data.msg, 1);
        } else {
          Toast.info("提交失败", 1, () => {
            this.getImageCode();
          });
        }
      });
  };
  render() {
    const { flagCode, count, status } = this.state;
    const { getFieldProps, getFieldError } = this.props.form;
    return (
      <div className="editPhone-wrapper">
        <form>
          <InputItem
            {...getFieldProps("newPassWordVerify", {
              // initialValue: 'little ant',
              rules: [
                { required: true, message: "请输入登录密码" },
                {
                  required: false,
                  pattern: new RegExp(
                    /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
                    "g"
                  ),
                  message: "请输入正确的密码",
                },
              ],
            })}
            clear
            type="password"
            error={!!getFieldError("newPassWordVerify")}
            placeholder="请输入登录密码"
            labelNumber={8}
          >
            登录密码
          </InputItem>
          <InputItem
            {...getFieldProps("phoneNumber", {
              // initialValue: 'little ant',
              rules: [{ required: true, message: "请输入新绑定手机号码" }],
            })}
            clear
            error={!!getFieldError("phoneNumber")}
            onErrorClick={() => {
              alert(getFieldError("phoneNumber").join("、"));
            }}
            placeholder="请输入新绑定手机号码"
            labelNumber={8}
          >
            手机号码
          </InputItem>
          <div className="item-cont">
            <InputItem
              {...getFieldProps("imageCode", {
                rules: [{ required: true, message: "请输入图片验证码" }],
              })}
              placeholder="请输入图片验证码"
              type=""
              labelNumber={8}
            >
              图片验证码
            </InputItem>
            <div
              className="code-image"
              onClick={() => {
                this.getImageCode();
              }}
            >
              <img src={this.state.imageKey.imageUrl || ""}></img>
            </div>
          </div>
          <div className="item-cont">
            <InputItem
              {...getFieldProps("phoneCode", {
                // initialValue: 'little ant',
                rules: [{ required: true, message: "请输入验证码" }],
              })}
              clear
              placeholder="请输入验证码"
              labelNumber={8}
            >
              手机验证码
            </InputItem>
            <div
              className="code-phone"
              onClick={() => {
                this.isPhone();
              }}
              style={{
                color: flagCode ? "#337fd3" : "#ccc",
                borderColor: flagCode ? "#337fd3" : "#ccc",
              }}
            >
              {flagCode ? "获取验证码" : `${count}S重新获取`}
            </div>
          </div>
        </form>
        <p
          style={{
            padding: "0.2rem",
            lineHeight: "0.2rem",
            textAlign: "center",
            color: "#BBBBBC",
          }}
        >
          提示： 一般情况下，一年内可重新绑定手机号码4次，此次是第{status + 1}
          次修改绑定手机号码。
        </p>
        <div
          style={{
            padding: "0 0.1rem",
            position: "absolute",
            left: "0",
            bottom: "0.2rem",
            width: "100%",
          }}
        >
          <Button type="primary" onClick={this.onSubmit}>
            提交
          </Button>
        </div>
      </div>
    );
  }
}
export default createForm()(EditPhone);
